import {
  generateRandomString,
  pkceChallengeFromVerifier,
  savePkceVerifier,
} from './sso-pkce'
import { config } from '@/shared/config'

export function useSsoLogin() {
  const startSsoLogin = async () => {
    const state = generateRandomString()
    const codeVerifier = generateRandomString()
    const code_challenge = await pkceChallengeFromVerifier(codeVerifier)

    savePkceVerifier(codeVerifier)

    const url = `${config.SSO_AUTHORIZE_URL}?response_type=code&client_id=${config.SSO_CLIENT_ID}&state=${state}&redirect_uri=${config.SSO_REDIRECT_URI}&code_challenge=${code_challenge}&code_challenge_method=S256&scope=${config.SSO_SCOPE}`
    window.location.href = url
  }

  return { startSsoLogin }
}
